import React from "react";

function Flask() {
  return (
    <svg
      width="94"
      height="132"
      viewBox="0 0 94 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M13 119C8.2 115.8 18 105.667 23.5 101C25.8333 100.333 31 99.4 33 101C35.5 103 42 101 46 97C49.2 93.8 53.6667 94 55.5 94.5L74 97C76.3333 102 81.6 113.6 84 120C87 128 56.5 126 40.5 125.5C24.5 125 19 123 13 119Z"
          fill="#11B4FA"
        />
        <path
          d="M84 138L77.5 137M23.5 101C18 105.667 8.2 115.8 13 119C19 123 24.5 125 40.5 125.5C56.5 126 87 128 84 120C81.6 113.6 76.3333 102 74 97L55.5 94.5C53.6667 94 49.2 93.8 46 97C42 101 35.5 103 33 101C31 99.4 25.8333 100.333 23.5 101Z"
          stroke="black"
        />
        <path
          d="M21.105 96.75L35.2872 67.4514V45.8333H58.8068V67.4514L72.9381 96.75"
          stroke="#E4F8FF"
          strokeWidth="9"
          strokeLinejoin="round"
        />
        <path
          d="M15.2633 123.526C13.7332 122.786 12.56 121.468 12.0017 119.862C11.4435 118.256 11.546 116.495 12.2866 114.964L21.105 96.75C21.105 96.75 35.25 106.542 47 96.75C58.75 86.9583 72.9401 96.75 72.9401 96.75L81.733 114.972C82.2044 115.95 82.42 117.031 82.3596 118.114C82.2992 119.197 81.9648 120.247 81.3877 121.166C80.8105 122.085 80.0096 122.842 79.0599 123.367C78.1103 123.892 77.0429 124.167 75.9579 124.167H18.0558C17.0884 124.167 16.1347 123.947 15.2633 123.526V123.526Z"
          stroke="#E4F8FF"
          strokeWidth="9"
          strokeLinejoin="round"
        />
        <circle className='circle_1' cx="44" cy="80" r="4" stroke="#E4F8FF" strokeWidth="4" />
        <circle className='circle_2' cx="48" cy="60" r="2.5" stroke="#E4F8FF" strokeWidth="3" />
        <circle className='circle_3' cx="37" cy="25" r="4" stroke="#E4F8FF" strokeWidth="4" />
        <circle className='circle_4' cx="54" cy="35" r="2.5" stroke="#E4F8FF" strokeWidth="3" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="94" height="132" fill="white" />
        </clipPath>
      </defs>
    </svg>
    
  );
}

export default Flask;
